import React from "react";
import { Table } from "reactstrap";

const Listing = ({ organization }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  // Add state for current page
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const itemsPerPage = 8; // Show one item at a time

  // Add useEffect for auto-scrolling
  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        (prevIndex + itemsPerPage) >= (organization?.length || 0) 
          ? 0 
          : prevIndex + itemsPerPage
      );
    }, 10000);

    return () => clearInterval(timer);
  }, [organization]);

  // Get current items to display
  const currentItems = organization?.slice(currentIndex, currentIndex + itemsPerPage) || [];

  // Add a CSS class for horizontal flip animation
  const horizontalFlipAnimation = {
    animation: "horizontalFlip 1.5s ease-in-out",
  };

  // Add keyframes for the horizontal flip effect
  const styles = `
  @keyframes horizontalFlip {
    0% {
      transform: rotateX(90deg);
      opacity: 0;
    }
    50% {
      transform: rotateX(45deg);
      opacity: 0.5;
    }
    100% {
      transform: rotateX(0deg);
      opacity: 1;
    }
  }
  `;

  // Inject styles into the document
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);

  return (
    <>
      <div className="card">
        <Table hover responsive className="mb-0">
          <thead>
            <tr>
              <th style={{ backgroundColor: "#0d6efd", color: "#ffffff" }}>Organization</th>
              <th style={{ backgroundColor: "#0d6efd", color: "#ffffff" }}>Last Document Uploaded</th>
              <th style={{ backgroundColor: "#0d6efd", color: "#ffffff" }}>Errors In Queue</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, i) => {
              return (
                <tr key={currentIndex + i} style={horizontalFlipAnimation}>
                  <td
                    className={`status-txt ${
                      item?.uploadedInTime == false || item?.monitoringAlertSent == true ? "text-danger" : ""
                    }`}
                    style={{ backgroundColor: i % 2 !== 0 ? "#B4D2FF" : "#ffffff" }}
                  >
                    {item?.name}
                  </td>
                  <td
                    style={{ backgroundColor: i % 2 !== 0 ? "#B4D2FF" : "#ffffff" }}
                    className={`status-txt ${
                      item?.uploadedInTime == false || item?.monitoringAlertSent == true ? "text-danger" : ""
                    }`}
                  >
                    {item?.latestDocument?.createdAt ? formatDate(item?.latestDocument?.createdAt) : "N/A"}
                  </td>
                  <td
                    className="status-txt"
                    style={{
                      backgroundColor: i % 2 !== 0 ? "#B4D2FF" : "#ffffff",
                      color : item?.errorCount > 10  ? "red" : "black"
                   }}
                  >
                    {item?.errorCount}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default Listing;
